export interface ContactMessage {
  readonly name: string;
  readonly email: string;
  readonly message: string;
}

export interface ContactResult {
  readonly ok: boolean;
  /** Arabic message to show the visitor when delivery failed. */
  readonly error?: string;
}

const ENDPOINT = '/api/contact';

const GENERIC_FAILURE = 'تعذّر إرسال الرسالة. تحقّق من اتصالك ثم حاول مرة أخرى.';

/**
 * Hand a message to the Pages Function that emails it.
 *
 * Never reports success it cannot stand behind: a network error, a non-2xx
 * response, or an unreadable body all surface as a failure the visitor can act
 * on, rather than a reassuring message over a lost note.
 */
export async function sendContactMessage(
  message: ContactMessage,
  signal?: AbortSignal,
): Promise<ContactResult> {
  let response: Response;

  try {
    response = await fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      // Empty honeypot: bots fill it, the visitor never sees it.
      body: JSON.stringify({ ...message, website: '' }),
      ...(signal ? { signal } : {}),
    });
  } catch {
    return { ok: false, error: GENERIC_FAILURE };
  }

  let body: { ok?: unknown; error?: unknown } = {};
  try {
    body = (await response.json()) as typeof body;
  } catch {
    /* fall through to the status check */
  }

  if (response.ok && body.ok === true) return { ok: true };

  return {
    ok: false,
    error: typeof body.error === 'string' && body.error ? body.error : GENERIC_FAILURE,
  };
}
